(function ($) {

    let styles = [{featureType: "all", elementType: "geometry.fill", stylers: [{weight: "2.00"}]}, {
        featureType: "all",
        elementType: "geometry.stroke",
        stylers: [{color: "#9c9c9c"}]
    }, {
        featureType: "all",
        elementType: "labels.text",
        stylers: [{visibility: "on"}]
    }, {
        featureType: "administrative.neighborhood",
        elementType: "labels.text",
        stylers: [{hue: "#ff9b00"}]
    }, {featureType: "landscape", elementType: "all", stylers: [{color: "#f2f2f2"}]}, {
        featureType: "landscape",
        elementType: "geometry.fill",
        stylers: [{color: "#ffffff"}]
    }, {
        featureType: "landscape.man_made",
        elementType: "geometry.fill",
        stylers: [{color: "#ffffff"}]
    }, {featureType: "poi", elementType: "all", stylers: [{visibility: "off"}]}, {
        featureType: "road",
        elementType: "all",
        stylers: [{saturation: -100}, {lightness: 45}]
    }, {featureType: "road", elementType: "geometry.fill", stylers: [{color: "#eeeeee"}]}, {
        featureType: "road",
        elementType: "labels.text.fill",
        stylers: [{color: "#7b7b7b"}]
    }, {
        featureType: "road",
        elementType: "labels.text.stroke",
        stylers: [{color: "#ffffff"}]
    }, {
        featureType: "road.highway",
        elementType: "all",
        stylers: [{visibility: "simplified"}]
    }, {
        featureType: "road.arterial",
        elementType: "labels.icon",
        stylers: [{visibility: "off"}]
    }, {featureType: "transit", elementType: "all", stylers: [{visibility: "off"}]}, {
        featureType: "water",
        elementType: "all",
        stylers: [{color: "#46bcec"}, {visibility: "on"}]
    }, {featureType: "water", elementType: "geometry.fill", stylers: [{color: "#c8d7d4"}]}, {
        featureType: "water",
        elementType: "labels.text.fill",
        stylers: [{color: "#070707"}]
    }, {featureType: "water", elementType: "labels.text.stroke", stylers: [{color: "#ffffff"}]}];

    function lmap(map, options) {
        var defaults = {
            map: {
                name: null,
                options: {
                    center: {
                        lat: 53.0765975,
                        lng: 8.8092175
                    },
                    zoom: 12,
                    draggable: true,
                    scrollwheel: false,
                    mapTypeControl: false,
                    streetViewControl: false,
                    zoomControl: true,
                    panControl: true,
                    fullscreenControl: false,
                    mapTypeControlOptions: {}
                },
                styles: styles

            },
            poi: {
                name: null,
                class: 'location-poi',
                clickable: true
            }
        };

        this.onlyOnePoi = true;
        this.config = $.extend(true, {}, defaults, options);
        this.$map = $(map);

    }

    lmap.prototype = {
        _resizeMap: function () {
            var that = this;
            $(window).on('resize', function () {
                that._centerMap();


                if ($('.page--srp__shortlist').length) {
                    that._positionRouteAside();
                }
            });


        },

        _select_poi: function (markerID) {

            var marker = this.markers[markerID];

            this.activeMarker = marker;

            this._centerMap();
        },

        _centerMap: function () {

            this._gMap.setCenter(this.config.center);
            this._gMap.setZoom(this.config.zoom);
        },

        _createPois: function () {
            var that = this;

            var $pois = this.config.poi;

            this.markers = {};

            if ($pois.length > 1) {
                that.onlyOnePoi = false;

            } else {
                that.onlyOnePoi = true;

            }

            this._gMapBounds = new google.maps.LatLngBounds();


            var i = 0;


            let iconZindex;
            for (i = 0; i < $pois.length; i++) {
                that._addMarkers($pois[i]);
            }

            this._mapCenter = this._gMapBounds.getCenter();
            this._centerMap();
            this._resizeMap();
        },

        _createMap: function () {
            this._gMap = new google.maps.Map(document.getElementById(this.config.map.id), this.config.map.options);
        },

        _createStyledMap: function () {
            var styledMap = new google.maps.StyledMapType(this.config.map.styles, {
                name: this.config.map.name
            });

            this.config.map.options.mapTypeControlOptions.mapTypeIds = [this.config.map.id];
            this._createMap();
            this._gMap.mapTypes.set(this.config.map.id, styledMap);
            this._gMap.setMapTypeId(this.config.map.id);
        },

        _getMapOptions: function () {
            this.config.map.id = this.$map.attr('id');

            var data = this.$map.data('map');

            if (data) {
                this.config.map.name = data[0];
            }
        },

        _navList: function () {
            var that = this;
            $('.location-link').click(function (e) {
                let locationID = $(this).data('location');

                let currentBubble = that.$map.trigger("select-poi", [locationID]);
                e.preventDefault();
            });
        },


        _addMarkers: function (marker) {
            var that = this;

            let window_title = marker['Title'];
            let category = marker['Cat'];
            let window_content = marker['Content'];
            if(marker['Content'] == 'null'){
              window_content = "";
            }
            //console.log(window_content);
            let pos = new google.maps.LatLng(parseFloat(marker['Lat']), parseFloat(marker['Lng']));
            let filter = marker['Letter'];
            let route = marker['Route'];
            let entryid = marker['ID'];
            let iconZindex = 101;

            let mapLabel;
            let iconbase = '/resources/images/img-single/';
            let svgicon = true;
            let image = marker['Image'];
            let icon;
            let markercolor;


            switch (category) {
                case 'tramstation':
                    mapLabel = {
                        text: "\ue530",
                        fontFamily: "Material Icons",
                        color: "#ffffff",
                        fontSize: "18px",
                    }
                    break;
                case 'pzone':
                    mapLabel = {
                        text: "\ue54f",
                        fontFamily: "Material Icons",
                        color: "#ffffff",
                        fontSize: "18px",
                    }
                    break;
                case 'store':
                    mapLabel = {
                        text: "\ue8cc",
                        fontFamily: "Material Icons",
                        color: "#ffffff",
                        fontSize: "18px",
                    }
                    break;
                case 'gastro':
                    mapLabel = {
                        text: "\ue561",
                        fontFamily: "Material Icons",
                        color: "#ffffff",
                        fontSize: "18px",
                    }
                    break;
                case 'freizeit':
                    mapLabel = {
                        text: "\uea66",
                        fontFamily: "Material Icons",
                        color: "#ffffff",
                        fontSize: "18px",
                    }
                    break;
                case 'culture':
                    mapLabel = {
                        text: "\uea66",
                        fontFamily: "Material Icons",
                        color: "#ffffff",
                        fontSize: "18px",
                    }
                    break;

                case 'poi':
                    svgicon = false;
                    icon = {
                        url: iconbase + 'icon--bremen-' + marker['IconName'] + '.png', // url
                        scaledSize: new google.maps.Size(50, 50), // scaled size
                        origin: new google.maps.Point(0, 0), // origin
                        anchor: new google.maps.Point(0, 0) // anchor
                    };
                    break;
            }

            if (marker['BGColor'] != '') {
                markercolor = marker['BGColor'];
                switch (markercolor) {
                    case 'grey':
                        that.markerImage.fillColor = '#aab6c0';
                        that.markerImage.strokeColor = '#aab6c0';
                        break;
                    case 'anthracite':
                        that.markerImage.fillColor = '#554f4a';
                        that.markerImage.strokeColor = '#554f4a';
                        break;
                    case 'lilac':
                        that.markerImage.fillColor = '#adb3ff';
                        that.markerImage.strokeColor = '#adb3ff';
                        break;
                    case 'oxid':
                        that.markerImage.fillColor = '#c2daba';
                        that.markerImage.strokeColor = '#c2daba';
                        break;
                    case 'bronze':
                        that.markerImage.fillColor = '#c4a472';
                        that.markerImage.strokeColor = '#c4a472';
                        break;
                    case 'brick':
                        that.markerImage.fillColor = '#e26a57';
                        that.markerImage.strokeColor = '#e26a57';
                        break;

                    case 'white':
                        that.markerImage.fillColor = '#ffffff';
                        that.markerImage.strokeColor = '#ffffff';
                        break;

                    default:
                        break;

                }
            } else {
                that.markerImage.fillColor = '#777777';
                that.markerImage.strokeColor = '#777777';
            }


            if (svgicon == true) {
                that.marker = new google.maps.Marker({
                    title: window_title,
                    position: pos,
                    category: category,
                    map: that._gMap,
                    label: mapLabel,
                    icon: that.markerImage,
                    entryid: 'srp--' + entryid
                });

                marker = that.marker;

                that.gmarkers.push(that.marker);



                if (image != '' && image != undefined) {
                    window_content = '<img src="' + image + '" alt="" style="display:block;max-width:100%;max-height:200px;margin:10px 0;">' + window_content + 'test';

                }
                if (route != '') {
                    window_content += '<br><a href="//maps.google.com/maps?daddr=' + route + '" target="_blank">Route planen</a>';
                }


                google.maps.event.addListener(that.marker, 'click', (function (marker, content) {
                    return function () {
                        marker.setIcon(that.markerImage);
                        marker.setIcon(that.markerImageActive);
                        marker.setZIndex(100);
                        that.infoWindow.setContent(
                            '<div class="t-def--sb gmap__title"> ' + window_title + '</div>' + '<div class="t-def htmleditor">' + window_content + '</div>'
                        );
                        that.infoWindow.open(that._gMap, marker);
                    }
                })(that.marker, window_content));
            } else {
                //pois

                that.marker = new google.maps.Marker({
                    title: window_title,
                    position: pos,
                    category: category,
                    map: that._gMap,
                    icon: icon
                });
            }
        },
        _filterMarker: function (filterkey, filterval) {
            var that = this;
            //https://jsfiddle.net/peter/drytwvL8/
            let i;
            for (i = 0; i < this.config.poi.length; i++) {
                let marker = that.gmarkers[i];
                let filtermarker;
                if (filterkey == 'category') {
                    filtermarker = marker.category;
                } else {
                    filtermarker = marker.letter;
                }

                if (marker.category == filterval || filterval.length === 0) {
                    marker.setVisible(true);
                }
                // Categories don't match
                else {
                    marker.setVisible(false);
                }
            }
        },

        _positionRouteAside: function () {
            this.routeAside = $('.page--srp__aside');
            this.routeFacts = $('.page--srp__teaser__facts');
            this.mainContainer = $('.main');
            this.scrollOnContainer = $('.scroll-on');
            this.breakpoint = 1240;
            // Aside Positionierung nur auf dem Desktop
            // setzte mindeshlhe of main Container
            // @TODO Breite abfragen
            const that = this;
            if (window.innerWidth > this.breakpoint) {
                let positionRouteFacts = that.routeFacts[0].getBoundingClientRect().top +
                    that.routeFacts[0].ownerDocument.defaultView.pageYOffset;
                that.routeAside
                    .css('top', positionRouteFacts + 'px')
                    .css('min-height', $('.page--srp__entries').outerHeight());
            } else {
                that.routeAside.attr('style', '');
            }

        },
//delete unused
        _setCurrentStation: function () {
            // aktiviert die aktuelle Station
            const that = this;
            const stationNavEntries = $('.page--srp__shortlist li');
            const stationShopInfos = $('.page--srp__entry__info');

            if (!!window.IntersectionObserver) {

                const routeStations = document.querySelectorAll(".page--srp__entry");
                const observerOptions = {rootMargin: "0px 0px -20%"};

                const observerForActiveRouteStations = new IntersectionObserver((entries, observer) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            const currentStation = entry.target.getAttribute("data-entry-srp");
                            stationNavEntries.removeClass('current');
                            $('[data-nav-srp="' + currentStation + '"]').addClass('current');

                            //stationShopInfos.removeClass('opacity--1');

                            $('[data-shopinfo-srp="' + currentStation + '"]').addClass('opacity--1');

                            that._filterPOIS();
                        }
                    });
                }, observerOptions);

                routeStations.forEach(function (station) {
                    observerForActiveRouteStations.observe(station);
                });
            }
        },
        _addCurPois: function () {

        },
        _filterPOIS: function () {

            let that = this;
            let pois_list = $('.page--srp__shortlist li');
            let cur_pois = $('.page--srp__shortlist li.current');
            let cur_id = cur_pois.attr('data-cg-id');

            var bounds = new google.maps.LatLngBounds();
            let i;


            for (i = 0; i < that.gmarkers.length; i++) {
                let marker = that.gmarkers[i];

                if (marker.entryid == cur_id) {
                    marker.setIcon(that.markerImageActive);
                    marker.setZIndex(100);
                } else {
                    marker.setIcon(that.markerImage);
                    marker.setZIndex(1);
                }

            }
        },
        init: function () {
            var that = this;

            that.gmarkers = [];
            that.markers = [];
            that.infoWindow = new google.maps.InfoWindow();

            that.pinSVGFilled = "M 12,2 C 8.1340068,2 5,5.1340068 5,9 c 0,5.25 7,13 7,13 0,0 7,-7.75 7,-13 0,-3.8659932 -3.134007,-7 -7,-7 z";
            that.labelOriginFilled = new google.maps.Point(12, 9);


            that.markerImageActive = {  // https://developers.google.com/maps/documentation/javascript/reference/marker#MarkerLabel
                path: that.pinSVGFilled,
                anchor: new google.maps.Point(12, 17),
                fillOpacity: 1,
                fillColor: '#e26a57',
                strokeWeight: 2,
                strokeColor: "#e26a57",
                scale: 1.75,
                labelOrigin: that.labelOriginFilled
            };
            that.markerImage = {  // https://developers.google.com/maps/documentation/javascript/reference/marker#MarkerLabel
                path: that.pinSVGFilled,
                anchor: new google.maps.Point(12, 17),
                fillOpacity: 1,
                fillColor: '#777777',
                strokeWeight: 2,
                strokeColor: "#777777",
                scale: 1.5,
                labelOrigin: that.labelOriginFilled
            };

            that.markerImageIndividual = {  // https://developers.google.com/maps/documentation/javascript/reference/marker#MarkerLabel
                path: that.pinSVGFilled,
                anchor: new google.maps.Point(12, 17),
                fillOpacity: 1,
                fillColor: '#777777',
                strokeWeight: 2,
                strokeColor: "#777777",
                scale: 1.5,
                labelOrigin: that.labelOriginFilled
            };


            that._getMapOptions();
            that._createMap();
            that._createStyledMap();
            that._createPois();
            that._navList();
            // Events
            //that.$map.on("select-poi", function(event, markerID) {
            //    that._select_poi(markerID);
            //});

            if ($('.page--srp__shortlist').length) {
                that._filterPOIS();
                that._positionRouteAside();
                that._setCurrentStation();

            }

            // $('.kw-tab__filter__branches a').on('click tap', function (e) {
            //     /*
            //     let curCategory = $(this).data('branch');
            //     that._filterMarker('category', curCategory);
            //     e.preventDefault();*/
            // });

            // $('.kw-tab__filter__alphabet a').on('click tap', function (e) {
            //     /*
            //     let curCategory = $(this).data('letter');
            //     console.log(curCategory);
            //     that._filterMarker('letter', curCategory);
            //     //e.preventDefault();*/
            // });
        }
    };

    $.fn.googleMap = function (options) {
        return this.each(function () {
            var GLMap = new lmap(this, options);
            GLMap.init();
        });
    };

})(jQuery);

window.initializeGoogleMaps = function () {
    var mapID = $("#gmap");
    if (mapID.length) {
        var map = mapID.googleMap({
            poi: map_markers,
            center: {
                lat: parseFloat(mapID.data('map')[1]),
                lng: parseFloat(mapID.data('map')[2])
            },
            zoom: parseInt(mapID.data('map')[3]),
            category: mapID.data('map')[4]
        });
    }

}

function CookieGoogleMaps(status) {

    let gmap = document.getElementById('gmap');
    let clink = document.getElementById('gmap-cookie');
    if (gmap) {
        if (status == 'show') {
            gmap.classList.remove('hide');
            clink.classList.add('hide');
        } else {
            gmap.classList.add('hide');
            clink.classList.remove('hide');
        }
    }
}

function allowGoogleMaps(e) {
    klaro.getManager().saveAndApplyConsents();
    klaro.getManager().updateConsent('googlemaps', true);
    klaro.getManager().saveAndApplyConsents();
}
